export enum PROGRAM_MODULE_FLAGS {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN'
}
